import { ModalBase } from "../../../components/Modals/ModalBase";
import BasicCardDocumentos from "../../OtrosDocumentos/Components/BasicCardDocumentos";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../reducers";
import InputForm from "../../OtrosDocumentos/Components/InputFormV2";
import { useState } from "react";
import { validarAlfanumericoEspacios, validarRegexNumericoFloat2Decimales } from "../../../utils/strings.utils";
import { generalOpenModalError, generalOpenModalInfo, generalShowLoader } from "../../../actions/general.actions";
import { apiSubirComprobanteGeneral, suscripcionGetDatosSuscripcion, GetValidarSaldo } from "../../../actions/suscripcion/suscripcion.actions";
import { bindActionCreators } from "redux";
import { actionsSuscripcion } from "../../../actions/action-creators";

export default function ModalComprobanteGeneral ({onClose, data} : {onClose: any, data: any}){
  const {tipoCargosMembresia, bancos} = useSelector((state: State) => state.catalogos)
  const {datos} = useSelector((state: State) => state.userLogin)
  const [Descripcion, setDescripcion] = useState('');
  const dispatch = useDispatch()

  const actions = bindActionCreators(actionsSuscripcion, dispatch)
  
  const [form, setForm] = useState<{[key:string] : any}>({
    tipoMembresia: '',
    banco: '',
    autorizacion: '',
    factura: '',
    comprobante: '',
    pago: '',
    monto: ''
  })

  const [errors, setErrors] = useState<{[key:string] : any}>({
    tipoMembresia: '',
    banco: '',
    autorizacion: '',
    factura: '',
    comprobante: '',
    pago: '',
    monto: ''
  })

  const [comprobante, setComprobante] = useState<any>('')

  const onChangeForm = (e: any) => {
    let name = e.target.name
    let value = e.target.value

    switch(name){
      case 'autorizacion':
      case 'factura':
        if(!validarAlfanumericoEspacios(value)) return
        break;
      case 'monto':
        if(!validarRegexNumericoFloat2Decimales(value)) return
        break;
      case 'tipoMembresia':
        const detalleTipo = tipoCargosMembresia?.find((val) => val?.codigo === value)?.valor
        setDescripcion(detalleTipo)
        break;
    }
    validateForm(name, value)

    setForm({
      ...form,
      [name] : value
    })
  }

  const onChangeComprobante = (e: any) => {
    try {
      const selectedFile = e.target.files[0]
      if(selectedFile){
          const reader = new FileReader();
          setForm({
              ...form,
              comprobante: e?.target?.value
          })

          reader.onload = () => {
              const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf('.'));
              const validTypes = ['.pdf']
              

              // Validar tamaño
              if (selectedFile.size > 2097152) { // 2MB en bytes
                setErrors({
                  ...errors,
                  comprobante: 'El tamaño del comprobante debe ser menor o igual a 2MB.'
                });
                return;
              }

              if(!validTypes.includes(fileExtension.toLowerCase())){
                  setErrors({
                      ...errors,
                      comprobante: 'Por favor, selecciona un archivo con una extensión válida. (.pdf)'
                  })
                  return;
              }
              setErrors({
                  ...errors,
                  comprobante: ''
              })
          }

          reader.onloadend = () => {
              
              if(typeof reader.result === 'string'){
                  const base64file = reader.result.split(',')[1];
                  setComprobante(base64file) 
              }
          }
          reader.readAsDataURL(selectedFile)
      } else {
        setForm({
          ...form,
          comprobante: ''
        })
      }
    } catch (error) {
      dispatch(generalOpenModalError('Ocurrió un error al cargar el comprobante, intenta cargarlo nuevamente.'))
    }
  }

  const validateForm = (name: string, value: string) => {
    let message = ''

    switch(name) {
      case 'tipoMembresia':
        if(!value) message = 'Tipo de transacción es requerido'
        break;
      case 'banco':
        if(!value) message = 'Banco es requerido'
        break;
      case 'autorizacion':
        if(value?.trim() === '') message = 'Autorización es requerida'
        break;
      // case 'factura':
      //     if(value?.trim() === '') message = 'Factura es requerida'
      //     break;
      case 'comprobante':
        if(value?.trim() === '') message = 'Comprobante es requerido'
        else message = errors.comprobante
        break;
      case 'pago':
        let hoy = new Date()
        let fecha = new Date(value)
        if(fecha > hoy){
            message = 'La fecha de pago no puede ser mayor a la fecha actual';
            break;
        }
        if(value?.trim() === '') message = 'Fecha de pago es requerida'
        break;
      case 'monto':
        if(value?.trim() === '') message = 'Monto es requerido'
        break;
    }

    setErrors({
      ...errors,
      [name] : message
    })

    return message;
  }
    
  const onClickSubir = async() => {
    let validations: {[key:string] : any} = {}

    for(const field in form){
      validations[field] = validateForm(field, form[field])
    }
    
    setErrors(validations)
    if(Object.values(validations).some((validation) => validation !== '')) return;

    try {
      dispatch(generalShowLoader(true))
      const body = {
        codigoempresa: datos?.codigo_empresa,
        descripcion: Descripcion,
        idbanco: form.banco,
        numautorizacion: form.autorizacion,
        pago: {
            iddetalleestadopago: data?.iddetalleestadopago,
            numerofactura: form.factura,
            fechapago: form.pago,
            monto: form.monto
        },
        username: datos?.username,
        documento: comprobante,
      }
      const response: any = await apiSubirComprobanteGeneral(body)
      if(response.status === 200){
          dispatch(generalOpenModalInfo(response.message ?? 'El comprobante fue actualizado exitosamente.'))
          actions.suscripcionGetDatosSuscripcion()
          onClose()
          dispatch(suscripcionGetDatosSuscripcion())
          dispatch(GetValidarSaldo())
      }
    } catch (error) {
        dispatch(generalOpenModalError('Ocurrió un error al guardar el comprobante'))
    } finally {
        dispatch(generalShowLoader(false));
    }
  }

  return(
    <ModalBase>
      <BasicCardDocumentos title= "Subir comprobante">
        <div className="form-content">
          
          <div className="w-layout-hflex h-inputs">
            <InputForm 
              required 
              keyNameText = 'codigo_nombre' 
              keyNameValue = 'codigo' 
              name = 'tipoMembresia' 
              placeholder = 'Tipo de transacción' 
              label = 'Tipo de transacción' 
              type = 'select' 
              error = {errors.tipoMembresia}
              value = {form.tipoMembresia} 
              defaultValue={"00"}
              onChange = {(e: any) => onChangeForm({target: {name: 'tipoMembresia',value: e.value}})}
              options = {[
                ...tipoCargosMembresia?.filter((tme) => tme.codigo !== "01")?.map((tm) => ({...tm, codigo_nombre: `${tm?.valor}`}))
              ]}
            />
            <InputForm required accept = ".pdf" containerClassname = 'file-input' inputClassname = 'text-field w-input upload_file_input' placeholder = 'Comprobante' label="Comprobante" type="file" value={form.comprobante} name="comprobante" error={errors.comprobante} onChange={onChangeComprobante}/>
          </div>
          <div className="w-layout-hflex h-inputs">
            <InputForm required options = {bancos} keyNameText = 'nombre' keyNameValue = 'idbanco' name = 'banco' placeholder = 'Banco' label = 'Banco' type = 'select' value = {form.banco} error = {errors.banco} onChange = {(e: any) => onChangeForm({target: {name: 'banco',value: e.value}})}/>
            <InputForm required placeholder = 'No. Autorización' label="No. Autorización" type="text" value={form.autorizacion} name="autorizacion" error={errors.autorizacion} onChange={onChangeForm}/>
          </div>
          <div className="w-layout-hflex h-inputs">
            <InputForm required label="Fecha de pago" type="date" value={form.pago} name="pago" error={errors.pago} onChange={onChangeForm}/>
            <InputForm required placeholder = '$0.00' label="Monto" type="text" value={form.monto} name="monto" error={errors.monto} onChange={onChangeForm}/>
          </div>
        </div>
        <hr className="separador"/>
        <div style={{display: 'flex', gap: '20px'}}>
          <button onClick={onClose} className="button transparent">Cancelar</button>
          <button onClick={onClickSubir} className="button">Subir</button>
        </div>
      </BasicCardDocumentos>
    </ModalBase>
  )
}